// extracted by mini-css-extract-plugin
export var layoutContainer = "_97-0";
export var layoutContainerNoRounding = "_97-6";
export var layoutContainerOpen = "_97-5";
export var layoutContainerResizing = "_97-1";
export var mainContent = "_97-2";
export var resizeDivider = "_97-3";
export var slidePanel = "_97-4";